import { useEffect, useState } from 'react';
import { Badge, Card, Group, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import dayjs from 'dayjs';
import HttpClient from '../../helpers/HttpClient';
import { useUserContext } from '../../providers/UserContext';
import { RENTAL_STATUS_COLORS, RENTAL_STATUS_LABELS, RentalRow, personName } from '../../types/inventory.type';

/** What the member (and their children) currently has or has reserved — keys, shirts, camera, ... */
export function MyRentalsSection() {
  const { currentPerson } = useUserContext();
  const [rentals, setRentals] = useState<RentalRow[]>([]);

  useEffect(() => {
    if (!currentPerson) return;
    new HttpClient<RentalRow>('/rental/mine').getAll().then(setRentals).catch(() => setRentals([]));
  }, [currentPerson]);

  if (rentals.length === 0) return null;

  return (
    <div data-tour="dashboard-my-rentals">
      <Title order={3} mb="sm">Meine Ausleihen</Title>
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }} spacing="sm">
        {rentals.map((r) => (
          <Card key={r.id} withBorder padding="sm" radius="md">
            <Group justify="space-between" wrap="nowrap" align="flex-start">
              <Stack gap={0} style={{ minWidth: 0 }}>
                <Text fw={600} truncate>
                  {r.quantity > 1 ? `${r.quantity}x ` : ''}{r.article.name}
                </Text>
                {r.variant.label !== 'Standard' && <Text size="sm" c="dimmed">{r.variant.label}</Text>}
              </Stack>
              <Badge color={r.isOverdue ? 'red' : RENTAL_STATUS_COLORS[r.status]} variant="light">
                {r.isOverdue ? 'Überfällig' : RENTAL_STATUS_LABELS[r.status]}
              </Badge>
            </Group>
            <Text size="sm" mt={4}>
              {r.status === 'out' ? 'Rückgabe bis ' : 'Ab '}
              {dayjs(r.status === 'out' ? r.plannedTo : r.plannedFrom).format('DD.MM.YYYY HH:mm')}
            </Text>
            {r.renter && r.renter.id !== currentPerson?.id && (
              <Text size="xs" c="dimmed">für {personName(r.renter)}</Text>
            )}
          </Card>
        ))}
      </SimpleGrid>
    </div>
  );
}
